import { useAuth } from '@on3/ui-lib/src/contexts/AuthProvider';
import React, { useEffect } from 'react';

import styles from './ExcoPlayer.module.scss';

export const ExcoPlayer = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.st?.includes('premium')) {
      const script = document.createElement('script');

      script.src = '//player.ex.co/player/34c93dc6-f9c2-4ad1-85ce-def4a929874b';
      script.async = true;
      script.className = 'exco-player';
      document.body.appendChild(script);
    }
  }, [user]);

  if (user?.st?.includes('premium')) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div id="34c93dc6-f9c2-4ad1-85ce-def4a929874b" />
    </div>
  );
};
